<script setup lang="ts">
/**
 * Top-right stacked region that renders the global notification queue
 * managed by `useNotificationsStore`. One `CdsInlineNotification` per
 * item, click-to-dismiss handled here so call sites just `notify.*()`.
 *
 * Mounted once by the library cutover (phase 3) inside `PmsShell.vue`.
 * Do NOT mount it in views or molecules.
 */
import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '@/stores/notifications.store'
import CdsInlineNotification from '../atoms/CdsInlineNotification.vue'

const store = useNotificationsStore()
const { items } = storeToRefs(store)
</script>

<template>
  <div class="fz-notification-container" aria-live="polite" role="status">
    <CdsInlineNotification
      v-for="item in items"
      :key="item.id"
      :variant="item.kind"
      kind="toast"
      :title="item.title"
      :subtitle="item.sub"
      close-label="Chiudi"
      @close="store.dismiss(item.id)"
    />
  </div>
</template>

<style scoped lang="scss">
.fz-notification-container {
  position: fixed;
  top: var(--spacing-05);
  right: var(--spacing-05);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  pointer-events: none;
}
.fz-notification-container > * {
  pointer-events: auto;
  min-width: 280px;
  max-width: 360px;
}
</style>
